<template>
    <div class="view fix-space__button">
        <DetailComponentRoom
            ref="DetailComponentRoom"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :child_href="child_href"
            :parent_id="parent_id"
            :rest_api_note="rest_api_note"
            :rest_api_lite="rest_api_lite"
            :title_page="title_page"
            :single_object="single_object"
            :single_object_backup="single_object_backup"
            :array_options="array_options"
            :form_format="form_format"
            :form_format2="form_format2"
            :notes="single_object.notes_entities"
            :back_href="'/building-rooms'"
            :map="false"
            :default_description="single_object.default_description"
            :comment_under_title="'This room has a custom description. It will not update with dynamic description behavior until the custom description is removed.'"
            :unalterable="true"
            @elementsGetter="elements_getter($event)"
            @saveOutside="saveGrid(false)"
            @confirmationRoomTypeMovement="modal_rt_confirmation($event)"
            @applyDefaultTasksModal="applyDefaultTasksModal(true, true)"
            :historiable="true"
            :confirmation_status="confirmation_status"
            :global_room_type="global_room_type"
            :suggested_floor_type="suggested_floor_type"
        />
        <div class="p-0 formdynamic__item col-md-auto">
            <div class="formdynamic__item__field position-relative operator" style="width: 10rem">
                <label for="Time adjustment:" class="modal-label active" v-html="single_object.patient ? 'Fixtures/Beds:' : '# of units'"/>
                <button type="button" class="button__operator" v-html="'+'" @click="single_object.fixture_number++"/>
                <button type="button" class="button__operator" v-html="'-'" @click="single_object.fixture_number--"/>
                <input type="number" class="input__operator" v-model="single_object.fixture_number" max="200" step=".01" pattern="\d+"/>
            </div>
        </div>
        <div class="row m-0 formdynamic pt-0">
            <div v-show="single_object.patient" class="mt-3 col-md-4 py-0" v-for="(item, i) in single_object.fixtures" :key="i">
                <div class="formdynamic__item__field" style="margin-right: 0">
                    <label for="Description:" class="modal-label" v-html="`Bed #${i+1}: <b style='color:red;'>*</b>`"/>
                    <input type="text" v-model="item.name" required style="max-width: 500px"/>
                </div>
            </div>
        </div>

        <div class="col px-0 mt-3">
            <hr/>
        </div>

        <div class="room__grid">

            <div>
                <div class="col-md-12">
                    <div class="row text-center text-md-left mt-lg-3" style="margin-left:-18px; margin-right:-18px;">
                        <div class="col-md-6 p-0 d-flex">
                            <div class="ml-2">
                                <a class="mx-md-0 modal__buttons__item w-auto h-auto px-3 lh-1 d-flex align-items-center justify-content-center"  v-html="'View associated assignments'" @click="assignments_modal()"/>
                            </div>
                            <div class="ml-2">
                                <a class="mx-md-0 modal__buttons__item w-auto h-auto px-3 lh-1 d-flex align-items-center justify-content-center" v-html="'Delete room'" @click="modal_deletion_local()"/>
                            </div>
                            <div class="ml-2">
                                <a class="mx-md-0 modal__buttons__item w-auto h-auto px-3 lh-1 d-flex align-items-center justify-content-center" v-html="'New room'" @click="form_modal_local()"/>
                            </div>
                            <div class="ml-2">
                                <a class="mx-md-0 modal__buttons__item w-auto h-auto px-3 lh-1 d-flex align-items-center justify-content-center" v-html="'QC History'" @click="form_modal_qc_history()"/>
                            </div>
                            <div class="ml-2">
                                <a class="mx-md-0 modal__buttons__item w-auto h-auto px-3 lh-1 d-flex align-items-center justify-content-center" v-html="'Project History'" @click="form_modal_project_history()"/>
                            </div>
                        </div>

                        <div class="col-md-6 py-0 d-flex justify-content-md-end" v-if="!single_object.child">
                            <div class="ml-2">
                                <a class="mx-md-0 modal__buttons__item w-auto h-auto px-3 lh-1 d-flex align-items-center justify-content-center" v-html="'Save changes'" @click="applyDefaultTasksModal(true, true)"/>
                            </div>
                            <div class="ml-2" v-if="rooms.length < 5">
                                <a class="mx-md-0 modal__buttons__item w-auto h-auto px-3 lh-1 d-flex align-items-center justify-content-center" v-html="'Add internal room'" @click="form_modal()"/>
                            </div>
                        </div>

                        <div class="col-md-6 py-0 d-flex justify-content-md-end" v-else>
                            <div class="mx-auto mr-md-0 ml-md-2"/>
                            <div class="mx-auto mx-md-0 ml-md-2 ml-md-0">
                                <a class="mx-md-0 modal__buttons__item w-auto px-3" v-html="'Add internal room'" v-if="parent_room_length < 5" @click="parent_room_length < 5 ? patner_form_modal() : null"/>
                            </div>
                        </div>
                    </div>
                </div>
                <RoomTable 
                    v-if="!single_object.child"
                    :table_selection="table_selection"
                    :table_headers="table_headers"
                    :single_select="single_select"
                    :rooms="rooms"
                    :search="search"
                    :child_href="child_href"
                />
            </div>

            <h2 class="view__title title--1" style="margin-top:50px;" v-html="'Task assigned to this Room'"/>

            <div class="alert alert-primary" role="alert">
                The <b>frequency</b> for <b>daily</b> and <b>policing</b> tasks is adjusted based on selected shifts: multiplied by 3 for three shifts, 2 for two shifts, and remains unchanged for one or no shifts. Select the appropriate shifts for the correct frequency.
            </div>
            <form @submit.prevent="form_submit()" class="room__grid__form">
                <div class="row mb-0">
                    <div class="col-lg-3 formdynamic__item__field">
                        <label class="modal-label" v-html="`Task: <b style='color:red;'>*</b>`"/>
                        <select required class="input-field custom-select mw-100" style="font-size: 13px; height: 32px;" v-model="task_form_data.task_id">
                            <option value="" v-html="'Tasks'"/>
                            <option v-for="(item, i) in array_options.task_id" :key="i" :value="item.id" v-html="`${item.name} - ${item.description}`"/>
                        </select>
                    </div>
                    <div class="col-lg-9 formdynamic__item__field">
                        <div class="row mb-0 text-center text-md-left">
                            <div class="col-md-3 col-sm-4 py-xl-0 formdynamic__item__field">
                                <label class="modal-label" v-html="`Production Standard: <b style='color:red;'>*</b>`"/>
                                <input :type="'text'" :value="task_selected.production_standard" :disabled="true"/>
                            </div>
                            <div class="col-md-2 py-xl-0 formdynamic__item__field">
                                <label :class="'modal-label'" v-html="`Frequency:`"/>
                                <div v-if="freq_manual">
                                    <input :type="'number'" v-model="task_form_data.frequency_manual" :min="'0'"  @change="changingTaskFrequency()"/>
                                    <label v-if="calculating_frequency_value">Calculating Frequency...</label>
                                </div>
                                <select required class="input-field custom-select" style="font-size: 13px; height: 32px;" v-model="task_form_data.frequency_id" v-else>
                                    <option value="" v-html="'Select an option'"/>
                                    <option v-for="(item, i) in array_options.frequency_id" :key="i" :value="item.id" v-html="`${item.name}`"/>
                                </select>
                            </div>
                            <div class="col-md-2 py-xl-0 formdynamic__item__field">
                                <label :class="'modal-label'" v-html="`+/- Minutes:`"/>
                                <!-- <input type="number" v-model="task_form_data.minutes_discount" :min="parseInt(-task_form_data.minutes)" :max="parseInt(task_form_data.minutes)"/> -->
                                <input type="number" v-model="task_form_data.minutes_discount" step=".01" :min="-1000" :max="1000"/>
                            </div>
                            <div class="col-md-2 py-xl-0 formdynamic__item__field">
                                <label :class="'modal-label'" v-html="'Minutes:'"/>
                                <input type="number" :step="'any'" :value="parseFloat(task_form_data.minutes)" :disabled="true"/>
                            </div>
                            <div :class="'col-lg-1 col-md-1 col-sm-12 formdinamic__item__field py-lg-0 pl-lg-0'">
                                <label :class="'modal-label d-block text-center text-md-left text-lg-center'" v-html="'Shift:'"/>
                                <div :class="'d-lg-flex justify-content-lg-between mt-2'">
                                    <span class="custom-control custom-checkbox">
                                        <input :id="'day'" :type="'checkbox'" :class="'custom-control-input'" v-model="task_form_data.shift1" @change="updateFrequencyValue()"/>
                                        <label :for="'day'" :class="'custom-control-label ml-2'" v-html="'1'"/>
                                    </span>
                                    <span class="custom-control custom-checkbox">
                                        <input :id="'evening'" :type="'checkbox'" :class="'custom-control-input'" v-model="task_form_data.shift2" @change="updateFrequencyValue()"/>
                                        <label :for="'evening'" :class="'custom-control-label ml-2'" v-html="'2'"/>
                                    </span>
                                    <span class="custom-control custom-checkbox">
                                        <input :id="'night'" :type="'checkbox'" :class="'custom-control-input'" v-model="task_form_data.shift3" @change="updateFrequencyValue()"/>
                                        <label :for="'night'" :class="'custom-control-label ml-2'" v-html="'3'"/>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="row text-center text-md-left mt-lg-3">
                            <div class="col-md-6 p-0 d-flex">
                                <div class="mx-auto mr-md-0 ml-md-2" style="display:none;">
                                    <button style="display:none;" :ref="'saveTaskButton'" class="mx-md-0 modal__buttons__item w-auto px-3" v-html="'Save task'"/>
                                </div>
                                <div class="mx-auto mx-md-0 ml-md-2 ml-md-0">
                                    <a class="mx-md-0 modal__buttons__item w-auto px-3" v-html="'Refresh page'" @click="api_request()"/>
                                </div>
                            </div>
                            <div class="col-md-6 py-0 d-flex justify-content-md-end">
                                <!-- <div class="mx-auto mx-md-0 ml-md-2 ml-md-0">
                                    <a class="mx-md-0 modal__buttons__item w-auto px-3" v-html="'Refresh'" @click="api_request()"/>
                                </div> -->
                                <div class="mx-auto mr-md-0 ml-md-2">
                                    <a style="display:none;" class="mx-md-0 modal__buttons__item w-auto px-3" v-html="'Save changes'" @click="applyDefaultTasksModal(true, true)"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="table-responsive room__table">
            <hr/>
            <div class="room__table__top text-center text-md-left d-md-flex align-items-md-center justify-content-md-between" v-if="daily_tasks.length" style="background: #f1f1f1; padding-top: 10px; padding-bottom: 10px;">
                <div class="room__table__top__defaults">
                    <span class="custom-control custom-checkbox">
                        <input :id="'dailyDisabled'" type="checkbox" class="custom-control-input" v-model="single_object.disabled_daily" @change="dailyDisabled()"/>
                        <label :for="'dailyDisabled'" class="custom-control-label ml-2" v-html="'Disable Daily Defaults'"/>
                    </span>
                </div>
                <div class="room__table__top__name">
                    <strong v-html="'Daily Tasks'"/>
                </div>
                <div class="room__table__top__button">
                    <div class="text-center text-md-left">
                        <!-- <a class="mx-md-0 modal__buttons__item" v-html="'QC History Report'"/> -->
                    </div>
                </div>
            </div>

            <table class="table" v-if="daily_tasks.length" id="daily_task">
                <thead>
                    <tr>
                        <th v-for="(item, i) in daily_task_table_headers" :key="i" scope="col" v-html="item.name" :style="item.style ? item.style : undefined"/>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in daily_tasks" :key="i" :id="`${item.name}${i}`">
                        <td>{{ i + 1 }}</td>
                        <td>
                            <span class="custom-control custom-checkbox">
                                <input 
                                    :id="`default_daily_${i}`" 
                                    :value="item.id" 
                                    :checked="single_object.daily_task_id === item.task_id" 
                                    type="checkbox" 
                                    class="custom-control-input" 
                                    @change="(event) => {
                                        if (event.target.checked) {
                                            single_object.daily_task_id = item.task_id; // Select the new task
                                        } else if (single_object.daily_task_id === item.task_id) {
                                            single_object.daily_task_id = null; // Deselect the task
                                        }
                                    }"
                                    />
                                <label :for="`default_daily_${i}`" class="custom-control-label"/>
                            </span>
                        </td>
                        <td>
                            <select required class="input-field custom-select mw-100" style="font-size: 13px; height: 32px;" v-model="item.task_id">
                                <option value="" v-html="'Tasks'"/>
                                <option v-for="(item, i) in dailyTasks" :key="i" :value="item.id" v-html="`${item.name} - ${item.description}`"/>
                            </select>
                        </td>
                        <td v-html="item.production_standard"/>
                        <td>
                            <input :id="`select1${i}`" type="number" class="form-control" v-model="item.frequency_manual" :placeholder="'Frequency'" :min="0" @change="() => { manualFrequencyInspection(i); changingTaskFrequencyOfExistingTask(item); }"/>
                            <label v-if="item.calculating_frequency_value">Calculating Frequency...</label>
                        </td>
                        <td style="width:100px;">
                            <input 
                                :id="`select_minute${i}`" 
                                type="number" 
                                class="form-control" 
                                v-model="item.minutes_discount"
                                :placeholder="'+/- Min'"
                                :max="1000"
                                :min="-1000"
                                @change="inspectionDailyMinute(i, item.minutes_discount)"
                            />
                        </td>
                        <td v-html="item.minutes"/>
                        <td v-html="item.min_modification"/>
                        <td v-html="item.is_default ? 'Yes' : 'No'"/>
                        <td>
                            <span class="custom-control custom-checkbox">
                                <input :id="`daily${i}`" v-model="item.shift1" type="checkbox" class="custom-control-input" @change="() => updateFrequencyValueOfExistingTask(item)"/>
                                <label :for="`daily${i}`" class="custom-control-label"/>
                            </span>
                        </td>
                        <td>
                            <span class="custom-control custom-checkbox">
                                <input :id="`daily2${i}`" v-model="item.shift2" type="checkbox" class="custom-control-input" @change="updateFrequencyValueOfExistingTask(item)"/>
                                <label :for="`daily2${i}`" class="custom-control-label"/>
                            </span>
                        </td>
                        <td>
                            <span class="custom-control custom-checkbox">
                                <input :id="`daily3${i}`" v-model="item.shift3" type="checkbox" class="custom-control-input" @change="updateFrequencyValueOfExistingTask(item)"/>
                                <label :for="`daily3${i}`" class="custom-control-label"/>
                            </span>
                        </td>
                        <td>
                            <a :href="`#daily_task`" class="room__table__link" v-html="'Delete'" @click="task_drop(i)"/>
                        </td>
                        <td>
                            <a :href="`#reset_daily_task`" class="room__table__link" v-html="'Reset'" @click="dailyMinutesReset(i)"/>
                        </td>
                    </tr>
                </tbody>
            </table>

            <hr/>
            <div class="room__table__top text-center text-md-left d-md-flex align-items-md-center justify-content-md-between" v-if="policing_tasks.length" style="background: #f1f1f1; padding-top: 10px; padding-bottom: 10px;">
                <div class="room__table__top__defaults">
                    <span class="custom-control custom-checkbox">
                        <input :id="'policingDisabled'" type="checkbox" class="custom-control-input" v-model="single_object.disabled_policing" @change="policingDisabled()"/>
                        <label :for="'policingDisabled'" class="custom-control-label ml-2" v-html="'Disable Policing Defaults'"/>
                    </span>
                </div>
                <div class="room__table__top__name">
                    <strong v-html="'Policing Tasks'"/>
                </div>
                <div class="room__table__top__button">
                    <div class="text-center text-md-left">
                        <!-- <a class="mx-md-0 modal__buttons__item" v-html="'QC History Report'"/> -->
                    </div>
                </div>
            </div>

            <table class="table" v-if="policing_tasks.length" id="policing_task">
                <thead>
                    <tr>
                        <th v-for="(item, i) in task_table_headers" :key="i" scope="col" v-html="item.name"/>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in policing_tasks" :key="i" :id="`${item.name}${i}`">
                        <td v-html="`${(i+1)}`"/>
                        <td>
                            <select required class="input-field custom-select mw-100" style="font-size: 13px; height: 32px;" v-model="item.task_id">
                                <option value="" v-html="'Tasks'"/>
                                <option v-for="(item, i) in policingTasks" :key="i" :value="item.id" v-html="`${item.name} - ${item.description}`"/>
                            </select>
                        </td>
                        <td v-html="item.production_standard"/>
                        <td>
                            <input :id="`select1_policing${i}`" type="number" class="form-control" v-model="item.frequency_manual" :placeholder="'Frequency'" :min="0" @change="() => { manualFrequencyInspectionPolicing(i); changingTaskFrequencyOfExistingTask(item); }"/>
                            <label v-if="item.calculating_frequency_value">Calculating Frequency...</label>
                        </td>
                        <td style="width:100px;">
                            <input 
                                :id="`select_policing_minute${i}`" 
                                type="number" 
                                class="form-control" 
                                v-model="item.minutes_discount"
                                :placeholder="'+/- Min'"
                                :max="1000"
                                :min="-1000"
                                @change="inspectionDailyMinute(i, item.minutes_discount)"
                            />
                        </td>
                        <td v-html="item.minutes"/>
                        <td v-html="item.min_modification"/>
                        <td v-html="item.is_default ? 'Yes' : 'No'"/>
                        <td>
                            <span class="custom-control custom-checkbox">
                                <input :id="`policing${i}`" v-model="item.shift1" type="checkbox" class="custom-control-input" @change="updateFrequencyValueOfExistingTask(item)"/>
                                <label :for="`policing${i}`" class="custom-control-label"/>
                            </span>
                        </td>
                        <td>
                            <span class="custom-control custom-checkbox">
                                <input :id="`policing2${i}`" v-model="item.shift2" type="checkbox" class="custom-control-input" @change="updateFrequencyValueOfExistingTask(item)"/>
                                <label :for="`policing2${i}`" class="custom-control-label"/>
                            </span>
                        </td>
                        <td>
                            <span class="custom-control custom-checkbox">
                                <input :id="`policing3${i}`" v-model="item.shift3" type="checkbox" class="custom-control-input" @change="updateFrequencyValueOfExistingTask(item)"/>
                                <label :for="`policing3${i}`" class="custom-control-label"/>
                            </span>
                        </td>
                        <td>
                            <a :href="`#policing`" class="room__table__link" v-html="'Delete'" @click="policing_drop(i)"/>
                        </td>
                        <td>
                            <a :href="`#reset_policing`" class="room__table__link" v-html="'Reset'" @click="policingMinutesReset(i)"/>
                        </td>
                    </tr>
                </tbody>
            </table>

            <hr/>
            <div class="room__table__top text-center text-md-left d-md-flex align-items-md-center justify-content-md-between" v-if="project_tasks.length" style="background: #f1f1f1; padding-top: 10px; padding-bottom: 10px;">
                <div class="room__table__top__defaults">
                    <span class="custom-control custom-checkbox">
                        <input :id="'projectDisable'" type="checkbox" class="custom-control-input" v-model="single_object.disabled_project" @change="projectDisabled()"/>
                        <label :for="'projectDisable'" class="custom-control-label ml-2" v-html="'Disable Project Defaults'"/>
                    </span>
                </div>
                <div class="room__table__top__name">
                    <strong v-html="'Project Tasks'"/>
                </div>
                <div class="room__table__top__button">
                    <div class="text-center text-md-left"/>
                </div>
            </div>

            <table class="table" v-if="project_tasks.length" id="project_task">
                <thead>
                    <tr>
                        <th v-for="(item, i) in task_project_table_headers" :key="i" scope="col" v-html="item.name"/>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in project_tasks" :key="i" :id="`${item.name}${i}`">
                        <td v-html="`${(i+1)}`"/>
                        <td>
                            <select required class="input-field custom-select mw-100" style="font-size: 13px; height: 32px;" v-model="item.task_id">
                                <option value="" v-html="'Tasks'"/>
                                <option v-for="(item, i) in projectTasks" :key="i" :value="item.id" v-html="`${item.name} - ${item.description}`"/>
                            </select>
                        </td>
                        <td v-html="item.production_standard"/>
                        <td>
                            <select class="input-field custom-select" style="font-size: 13px; height: 32px;" v-model="item.frequency_id" :id="`selectFreq${i}`">
                                <option value="" disabled v-html="'Select frecuency:'"/>
                                <option v-for="(prop, j) in frequencies" :key="j" :value="prop.id" v-html="prop.name"/>
                            </select>
                        </td>
                        <!-- <td v-html="item.minutes_discount"/> -->
                        <td style="width:100px;">
                            <input 
                                :id="`select_project_minute${i}`" 
                                type="number" 
                                class="form-control" 
                                v-model="item.minutes_discount" 
                                :placeholder="'+/- Min'"
                                :max="1000"
                                :min="-1000"
                                @change="inspectionProjectMinute(i, item.minutes_discount)"
                            />
                        </td>
                        <td v-html="item.minutes"/>
                        <td v-html="item.min_modification"/>
                        <td v-html="item.last_completed"/>
                        <td v-html="item.is_default_project ? 'Yes' : 'No'"/>
                        <td>
                            <span class="custom-control custom-checkbox">
                                <input :id="`project${i}`" v-model="item.shift1" type="checkbox" class="custom-control-input"/>
                                <label :for="`project${i}`" class="custom-control-label"/>
                            </span>
                        </td>
                        <td>
                            <span class="custom-control custom-checkbox">
                                <input :id="`project2${i}`" v-model="item.shift2" type="checkbox" class="custom-control-input"/>
                                <label :for="`project2${i}`" class="custom-control-label"/>
                            </span>
                        </td>
                        <td>
                            <span class="custom-control custom-checkbox">
                                <input :id="`project3${i}`" v-model="item.shift3" type="checkbox" class="custom-control-input"/>
                                <label :for="`project3${i}`" class="custom-control-label"/>
                            </span>
                        </td>
                        <td>
                            <a href="#project_task" class="room__table__link" v-html="'Delete'" @click="project_drop(i)"/>
                        </td>
                        <td>
                            <a :href="`#reset_daily_task`" class="room__table__link" v-html="'Reset'" @click="projectMinutesReset(i)"/>
                        </td>
                        <td>
                            <a :href="`#view`" class="room__table__link" v-html="'View'" @click="viewProjectTask(i)"/>
                        </td>
                    </tr>
                </tbody>
            </table>

            <hr/>

            <div class="col-md-12">
                <div class="row text-center text-md-left mt-lg-3">
                    <div class="col-md-6 p-0 d-flex"/>
                    <div class="col-md-6 py-0 d-flex justify-content-md-end">
                        <div class="mx-auto mr-md-0 ml-md-2">
                            <a class="mx-md-0 modal__buttons__item w-auto px-3" v-html="'Save changes'" @click="applyDefaultTasksModal(true, true)"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <WaitingModal/>

        <FormModal
            ref='formModal'
            :title="`This Room is an internal room to ${this.single_object.description}`"
            :rooms_length="rooms.length"
            :breadcrumb="breadcrumb"
            :rest_api="parent_rest_api"
            :notyf="notyf"
            :bed_numbers="bed_numbers"
            :array_options="array_options"
            :next_walking_number="child_next_walking_number"
            :parent_id="parent_id"
            :from_child="true"
            :parent="single_object"
            @unshiftObject="unshift_object($event)"
        />

        <FormModal
            ref="newRoom"
            :title="'New Room'"
            :breadcrumb="breadcrumb"
            :rest_api="parent_rest_api"
            :notyf="notyf"
            :bed_numbers="bed_numbers"
            :array_options="array_options"
            :next_walking_number="next_walking_number"
            :from_child="false"
            :save_view="true"
            @saveView="save_and_view($event)"
            @unshiftObject="unshift_object($event)"
        />

        <PatnerFormModal
            ref="patnerRoom"
            :title="`This Room is an internal room to ${this.single_object.parent_description}`"
            :rooms_length="parent_room_length"
            :breadcrumb="breadcrumb"
            :rest_api="parent_rest_api"
            :notyf="notyf"
            :bed_numbers="bed_numbers"
            :array_options="array_options"
            :next_walking_number="child_next_walking_number"
            :parent_id="parent_id"
            :from_child="true"
            :parent="single_object"
            @unshiftObject="patner_unshift_object($event)"
        />

        <DailyAssignmentsModal
            :title="`Associated assignments`"
            :title_two="single_object.description"
            :assignment_table_headers="assignment_table_headers"
            :assignments="assignments"
            :breadcrumb="breadcrumb"
            :parent_id="single_object.uncrypted_id"
        />

        <ModalChangesConfirmation 
            :ref="'ModalChangeConfirmation'"
            :floor_name_confirmation="floor_name_confirmation"
            @ReturnConfirmation="getConfirmationRT($event)"
            @projectConfirmMutation="single_object.project_confirm = $event"
        />

        <DeletionModal
            :single_object="single_object" 
            :global_index="1"
            :local="true"
            :id="'static-deletion-detail'"
            @objectDeletionLocal="object_deletion_local($event)"
        />

        <ProjectCompleteModal 
            :title="'Complete Project Task'"
            :rest_api="'rooms_project_complete'"
            :notyf="notyf"
            :breadcrumb="breadcrumb"
            :parent="parent"
            ref="projectCompleteModal"
        />

        <RoomInspectionHistoryModal 
            :title="'QC History'"
            :history="qc_history"
            :breadcrumb="breadcrumb"
            ref="roomInspectionHistoryModal"
        />

        <RoomProjectHistoryModal 
            :title="'Project History'"
            :history="project_history"
            :breadcrumb="breadcrumb"
            ref="roomProjectHistoryModal"
        />

        <ApplyDefaultTasksModal
            title="Apply Default Codes" 
            :breadcrumb="breadcrumb"
            :daily_tasks="daily_tasks"
            :policing_tasks="policing_tasks"
            :suggested_daily_tasks="suggested_daily_tasks"
            :suggested_policing_tasks="suggested_policing_tasks"
            :assignments="assignments"
            @applyDefaultTasks="applyDefaultTasks"
            @beforeSaveGrid="beforeSaveGrid"
            :apply_default_tasks_methods="apply_default_tasks_methods"
        />

    </div>
</template>

<script>

import FormResources                from    './form_resources'
import Resources                    from    './resources'
import DetailLocalMethods           from    './DetailLocalMethods'
import DetailComponentRoom          from    '@/components/DetailComponent/DetailComponentRoom'
import DailyAssignmentsModal        from    './ChildComponents/DailyAssignmentsModal'
import ModalChangesConfirmation     from    './ChildComponents/ModalChangesConfirmation'
import ChildFormResources           from    './ChildFormResources'
import RoomTable                    from    './ChildComponents/RoomTable'
import FormModal                    from    './FormModal'
import PatnerFormModal              from    './PatnerFormModal'
import ProjectCompleteModal         from    './ProjectCompleteModal'
import RoomInspectionHistoryModal   from    './RoomInspectionHistoryModal'
import RoomProjectHistoryModal      from    './RoomProjectHistoryModal'
import WaitingModal                 from    '@/components/WaitingModal'
import DeletionModal                from    '@/components/DeletionModal'
import LocalHelper                  from    './LocalHelper'
import { Notyf }                    from    'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css' // for React and Vue
import ApplyDefaultTasksModal from './ApplyDefaultTasksModal'
const notyf = new Notyf({
    duration: 8000,
});

export default {
    
    name: 'RoomDetail',

    components: {
    DetailComponentRoom,
    WaitingModal,
    FormModal,
    RoomTable,
    DailyAssignmentsModal,
    DeletionModal,
    PatnerFormModal,
    ModalChangesConfirmation,
    ApplyDefaultTasksModal,
    ProjectCompleteModal,
    RoomInspectionHistoryModal,
    RoomProjectHistoryModal
},

    mixins:[
        DetailLocalMethods,
        LocalHelper,
    ],
    
    data(){
        return{
            notyf,
            parent_id:                  this.$route.params.id,
            parent_rest_api:            `rooms`,
            rest_api:                   `rooms/${this.$route.params.id}`,
            ext_rest_api:               `room_tasks`,
            lite_rest_api:              `rooms`,
            rest_api_lite:              `/rooms`,
            rest_api_note:              `room_notes`,
            child_href:                 '/building-room/',
            form_format:                FormResources.form_format,
            form_format2:               FormResources.form_format2,
            task_form_data:             FormResources.task_form_data,
            task_form_data_backup:      {...FormResources.task_form_data},
            breadcrumb:                 Resources.breadcrumb,
            task_table_headers:         Resources.task_table_headers,
            daily_task_table_headers:   Resources.daily_task_table_headers,
            task_project_table_headers: Resources.task_project_table_headers,
            frequencies:                Resources.frequencies,
            assignment_table_headers:   Resources.assignment_table_headers,

            parent_room_length:         0,

            patient_counter:            0,
            search:                     '',
            single_select:              false,
            table_selection:            [],
            table_headers:              Resources.table_headers,

            title_page:                 '',
            task_selected:              {},

            /**------------------------------------------------ */
            single_object:              {},
            single_object_backup:       {},
            fixtures_backup:            [],
            /**------------------------------------------------ */

            tasks:                      [],
            daily_tasks:                [],
            policing_tasks:             [],
            project_tasks:              [],
            backup_daily_tasks:         [],
            backup_project_tasks:       [],
            daily_tasks_backup:         [],
            project_tasks_backup:       [],
            assignments:                [],
            rooms:                      [],
            bed_numbers:                {},
            array_options:              {},
            freq_manual:                true,
            daily_disabled:             false,
            abbreviation:               '',
            door_number:                '',
            next_walking_number:        0,
            child_next_walking_number:  0,
            submit_reactive:            false,
            new_tasks:                  false,
            save_view:                  false,

            floor_name_confirmation:    null,
            confirmation_status:        true,
            global_room_type:           null,
            first_time:                 1,

            floor_count: 0,
            daily_task_count: 0,
            backup_description: '',
            backup_description_2 : '',
            is_description_dynamic: true,
            suggested_floor_type: null,
            first_time_door_number: true,
            suggested_daily_tasks: [],
            suggested_policing_tasks: [],
            apply_default_tasks_methods: '',
            calculating_frequency_value: false,
            clicked_save: true,
            qc_history: [],
            project_history: []
        }
    },

    async mounted()
    {
        if(this.hasPermissions(['Building-Room Read']))
        {
            await this.api_request(this.rest_api);

            if(this.single_object.child)
            {
                this.form_format = ChildFormResources.form_format
                this.parent_room_length = this.single_object.child_counter
            }

            this.$refs.newRoom.modal_name = 'static-local'
        }
    },

    methods: {
        async dailyMinutesReset(index)
        {
            let confirmation = window.confirm('Are you sure to make this change?')

            if(confirmation)
            {
                let json_request = {
                    minutes_reset: true,
                    room_task_id: this.daily_tasks[index].id,
                }
                let room_task = await this.minutesReset(json_request)

                this.daily_tasks.splice(index, 1, room_task)
            }
        },

        async policingMinutesReset(index)
        {
            let confirmation = window.confirm('Are you sure to make this change?')

            if(confirmation)
            {
                let json_request = {
                    minutes_reset: true,
                    room_task_id: this.policing_tasks[index].id,
                }
                let room_task = await this.minutesReset(json_request)

                this.policing_tasks.splice(index, 1, room_task)
            }
        },

        async projectMinutesReset(index)
        {
            let confirmation = window.confirm('Are you sure to make this change?')

            if(confirmation)
            {
                let json_request = {
                    minutes_reset: true,
                    room_task_id: this.project_tasks[index].id,
                }
                let room_task = await this.minutesReset(json_request)

                this.project_tasks.splice(index, 1, room_task)
            }
        },

        async viewProjectTask(index)
        {
            this.$refs.projectCompleteModal.getInitialData(this.project_tasks[index])
            window.$('#static-project-complete').modal('show')

        },

        async form_modal_qc_history()
        {
            this.loader(true)
            const response = await this.get(`rooms_inspection_history/${this.single_object.uncrypted_id}`)
            this.loader()

            if(response.status)
            {
                this.qc_history = response.data.history
                window.$('#static-room-inspection-history').modal('show')
                console.log(response.data);
            }
            else
            {
                this.error_handling(response)
            }
        },

        async form_modal_project_history()
        {
            this.loader(true)
            const response = await this.get(`rooms_project_complete_history/${this.single_object.uncrypted_id}`)
            this.loader()

            if(response.status)
            {
                this.project_history = response.data.completed_dates
                window.$('#static-room-project-history').modal('show')
                console.log(response.data);
            }
            else
            {
                this.error_handling(response)
            }
        },

        async minutesReset(json_request)
        {

            this.loader(true)

            let response = await this.get(`${this.ext_rest_api}/${JSON.stringify(json_request)}`)

            if(response.status)
            {
                // console.log(response.data)
                this.loader()
                return response.data.room_task
            }
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

        getConfirmationRT(event)
        {
            if(!event)
            {
                this.single_object.floor_id = this.single_object_backup.floor_id
            }

            this.confirmation_status = true

            setTimeout(()=> { 
                this.$refs.DetailComponentRoom.live_edition(true)
                this.$refs.ModalChangeConfirmation.floor_confirm = false
                this.$refs.ModalChangeConfirmation.project_confirm = false
            }, 500)
            
            window.$('#changes-confirmation').modal('hide')
        },

        modal_rt_confirmation(event)
        {
            this.floor_name_confirmation = this.array_options.floor_id.find(item => item.id === event.floor_id).name
            // console.log(this.floor_name_confirmation, 'floor_name_confirmation')
            window.$('#changes-confirmation').modal('show')
        },
        
        async unshift_object(new_object)
        {
            if(this.save_view)
            {
                window.location.href = `${this.child_href}${new_object.id}`
                return true
            }
            
            this.rooms.push(new_object)

            if(this.rooms.length >= 5)
            {
                window.$('#static-child').modal('hide')
                return false
            }
            await this.get_child_next_walking_number(this.single_object.id, this.single_object.area_id)
        },
        
        async patner_unshift_object(new_object)
        {
            if(this.save_view)
            {
                window.location.href = `${this.child_href}${new_object.id}`
                return true
            }
            
            // this.rooms.push(new_object)

            this.parent_room_length = new_object.child_counter

            if(this.parent_room_length >= 5)
            {
                window.$('#static-patner').modal('hide')
                return false
            }
            await this.get_child_next_walking_number(this.single_object.room_id, this.single_object.area_id)
        },

        applyDefaultTasksModal(room_type_change = true, clicked_save = false)
        {
            if(room_type_change)
            {
                const default_daily_tasks = this.daily_tasks.filter(daily_task => daily_task.is_default)
                const default_policing_tasks = this.daily_tasks.filter(policing_task => policing_task.is_default)

                this.clicked_save = clicked_save

                if(this.single_object_backup.room_type_id != this.single_object.room_type_id && ((this.suggested_daily_tasks.length && default_daily_tasks.length) || (this.suggested_policing_tasks.length || default_policing_tasks.length)))
                {
                    window.$('#static-apply-default-tasks').modal('show')
                    this.apply_default_tasks_methods = 'beforeSaveGrid'
                }
                else
                {
                    this.saveGrid(this.clicked_save)
                }
            }
            else
            {
                this.clicked_save = true
                window.$('#static-apply-default-tasks').modal('show')
                this.apply_default_tasks_methods = 'applyDefaultTasks'
            }
        },

        async applyDefaultTasks(event)
        {
            this.loader(true)
            const response = await this.put(`${this.parent_rest_api}/default_tasks/apply/${this.single_object.uncrypted_id}`, event.replaced_tasks)
            this.loader()

            if(response.status)
            {
                this.task_getter(response.data.room_tasks)
                this.notyfMesg('Success')
            }
            else
            {
                this.error_handling(response)
                window.$('#static-apply-default-tasks').modal('show')
            }
        },

        async beforeSaveGrid(event)
        {
            this.saveGrid(this.clicked_save, event.replaced_tasks)
        },

        form_modal()
        {
            if(this.rooms.length >= 5)
            {
                return false
            }
            window.$('#static-child').modal('show')
        },

        patner_form_modal()
        {
            if(this.single_object.child_counter >= 5)
            {
                return false
            }

            const fields = { 
                area_id: this.single_object.area_id,
                room_type_id: this.single_object.room_type_id,
                sq_ft: this.single_object.sq_ft,
                room_id: this.single_object.room_id, 
            }
            this.$refs.patnerRoom.set_fields(fields)
            window.$('#static-patner').modal('show')
        },

        assignments_modal()
        {
            if(!this.assignments.length)
            {
                notyf.error('No Assignments available for this room')
                return false
            }
            window.$('#assignments-window').modal('show')
        },

        includes_areas()
        {
            for (const area of this.array_options.area_id)
            {
                if(this.single_object.description.includes(area.name))
                {
                    return true
                }    
            }
            return false
        },

        modal_deletion_local()
        {
            window.$('#static-deletion-detail').modal('show')
        },

        async object_deletion_local(object_destroyed)
        {
            this.invoke_loader('delete')
            const response = await this.delete(`${this.parent_rest_api}/${object_destroyed.id}`)
            this.revoke_loader('delete')
            if(response.status)
            {
                window.$('#static-deletion-local').modal('hide')
                this.notyf.success('Deleted success!')
                await this.delay(1000)
                window.location.href = '/building-rooms'
            } 
            else
            {
                this.error_handling(response)
            }
        },

        form_modal_local()
        {
            const fields = { 
                area_id: this.single_object.area_id,
                room_type_id: this.single_object.room_type_id,
                sq_ft: this.single_object.sq_ft,
                description_2: this.single_object.description_2, 
                fixtures:  this.single_object.fixtures
            }
            this.$refs.newRoom.set_fields(fields)
            window.$('#static-local').modal('show')
        },

        fixtureChange(val, oldVal)
        {
            if(this.single_object.patient)
            {
                val = val.toString()
                val = val.replace(/[^\d]/g, '');
                this.single_object.fixture_number = val

                if(val.length > 1)
                {
                    val = val.slice(0, 1)
                    this.single_object.fixture_number = val
                    this.notyfMesg('No decimal values allowed', 'error')
                }

                if(this.single_object.fixture_number > 6)
                {
                    val = 6
                    this.single_object.fixture_number = val
                    this.notyfMesg('Up to 6 beds', 'error')
                }


                if(val < oldVal || val < this.single_object.fixtures.length)
                {
                    if(this.single_object.fixtures.length >= val)
                    {
                        this.single_object.fixtures = this.single_object.fixtures.slice(0, val)
                    }
                }
                else
                {
                    let new_beds_number = val - this.single_object.fixtures.length
                    
                    for (let index = 0; index < new_beds_number; index++) 
                    {
                        let number_position = 0
                        let rounds = 0

                        if(this.bed_numbers.length > this.single_object.fixtures.length)
                        {
                            number_position = this.single_object.fixtures.length
                        }
                        else
                        {
                            rounds = Math.floor(this.single_object.fixtures.length / this.bed_numbers.length)
                            number_position = this.single_object.fixtures.length - (rounds * this.bed_numbers.length) + 1
                        }

                        let concat_prefix = ''
                        let bed_number = this.bed_numbers[number_position] || ''

                        if(this.single_object.door_number === '' || this.single_object.door_number === null)
                        {
                            concat_prefix = `${this.single_object.fixtures.length+1} ${bed_number}`
                        }
                        else
                        {
                            concat_prefix = `${this.single_object.door_number}${bed_number}`
                        }

                        concat_prefix = rounds ? `${concat_prefix} | ${rounds}` : concat_prefix

                        if(this.single_object.fixtures.length < 6 || !this.single_object.patient)
                        {
                            this.single_object.fixtures.push({ id: '', name: concat_prefix })
                        } 
                        
                    } 
                }
            }
            else
            {
                if(val > 200)
                {
                    val = 200
                    this.single_object.fixture_number = 200
                    this.notyfMesg('Up to 200 fixtures', 'error')
                }

            }
        },

        save_and_view(event)
        {
            this.save_view = event
        },

    },

    watch: {
        async "single_object.fixture_number" (val, oldVal)
        {
            this.fixtureChange(val, oldVal)
        },

        async "single_object.floor_id"(val)
        {
            if(this.floor_count && this.single_object.daily_task_id)
            {
                await this.defaultProjectTaskCoincidence(val, this.single_object.daily_task_id)
            }

            this.suggested_floor_type = this.array_options['floor_id'].find((data) => data.id === this.global_room_type['floor_id'] || null)
            this.floor_count++
        },

        async "single_object.description"(val)
        {
            if(val.length == 0 || !val)
            {
               this.is_description_dynamic = false;
            }
            
        },

        async "single_object.daily_task_id"(val)
        {
            if(this.daily_task_count && val && this.single_object.floor_id)
            {
                await this.defaultProjectTaskCoincidence(this.single_object.floor_id, val)
            }
            this.daily_task_count++
        },

        'task_form_data.task_id'(val)
        {
            let task_id = val 

            let task_length = this.daily_tasks.filter(item => item.task_id === task_id)
            let policing_length = this.policing_tasks.filter(item => item.task_id === task_id)
            let project_length = this.project_tasks.filter(item => item.task_id === task_id)


            if(task_length.length || policing_length.length || project_length.length)
            {
                this.task_form_data = {...this.task_form_data_backup}
                notyf.error('The selected task already exist')
                return false
            }

            if(this.freq_manual)
            {
                let found_area = this.array_options.area_id.find(item => item.id === this.single_object.area_id)

                this.task_form_data.frequency_manual = found_area ? found_area.frequency : ''

                this.changingTaskFrequency()
            }

        },

        defaultDescription(val)
        {
            if (this.single_object.description === '' || this.is_description_dynamic)
            {
                if(val)
                {
                    this.is_description_dynamic = true;
                    this.single_object.description = val
                }
            }
            else
            {
                this.is_description_dynamic = false;
            }     
            
        },

    },

    computed:
    {
        defaultDescription()
        {
            let area = ''
            let room_type = ''
            if(this.single_object.area_id)
            {
                area = this.array_options.area_id.find(value => value.id == this.single_object.area_id).name
            }

            if(this.single_object.room_type_id)
            {
                room_type = this.array_options.room_type_id.find(value => value.id == this.single_object.room_type_id).abbrevation
            }
            return area + (room_type ? ` ${room_type}` : '') + (this.single_object.door_number ? ` ${this.single_object.door_number}` : '') + (this.single_object.description_2 ?` ${this.single_object.description_2}` : '')
        },
        dailyTasks()
        {
            return this.array_options.task_id.filter(item => item.project == 0 && item.policing == 0)
        },
        policingTasks()
        {
            return this.array_options.task_id.filter(item => item.project == 0 && item.policing == 1)
        },
        projectTasks()
        {
            return this.array_options.task_id.filter(item => item.project == 1 && item.policing == 0)
        }
        
    }

}
</script>